import { ArrowRight } from "lucide-react";
import { SITE } from "@/config/site";
import { trackEvent } from "@/lib/analytics";

// Jediné místo, odkud vede nákup do SimpleShopu.
// Všechna prodejní tlačítka na webu používají tuto komponentu.

export const CtaButton = ({
  children,
  event,
  location,
  variant = "gold",
  size = "md",
  className = "",
  testId = "cta-button",
}) => {
  const base =
    "group inline-flex items-center justify-center gap-3 rounded-full font-sans font-semibold tracking-wide uppercase transition-[background-color,color,transform,box-shadow] duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-copper focus-visible:ring-offset-2 focus-visible:ring-offset-navy";
  const sizes = {
    sm: "px-6 py-3 text-xs",
    md: "px-8 py-4 text-sm",
    lg: "px-10 py-5 text-sm sm:text-base",
  };
  const variants = {
    gold: "bg-[linear-gradient(135deg,#d08a5c,#a65a3a)] text-cream hover:bg-[linear-gradient(135deg,#dc9a6c,#b4653f)] hover:shadow-[0_12px_44px_-10px_rgba(201,127,82,0.55)] active:scale-[0.98]",
    outline:
      "border border-cream/30 text-cream hover:border-copper hover:text-copper active:scale-[0.98]",
    dark: "bg-navy text-cream hover:bg-navy-deep active:scale-[0.98]",
  };

  return (
    <a
      href={SITE.checkoutUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      onClick={() => {
        if (event) trackEvent(event, { location });
        trackEvent("checkout_click", { location });
      }}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      <span>{children}</span>
      <ArrowRight
        className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
        aria-hidden="true"
      />
    </a>
  );
};
